import { render, staticRenderFns } from "./DialogEditarVersao.vue?vue&type=template&id=92c180fe&"
import script from "./DialogEditarVersao.vue?vue&type=script&lang=js&"
export * from "./DialogEditarVersao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports